import request from './api';
import { API_EVENTS, API_EVENTS_USER } from '../constants/api';

import { convertDateToUTC } from './dates';

/**
 * Gets events for the user 'user' for a specific month and year.
 * If there's no month or year, current date will be used.
 * If there's year but not month, all the events of that year will be retrieved.
 * @param {string} user - The user id
 * @param {(string|number)} [year] - year where the events happen
 * @param {(string|number)} [month] - month where the events happen
 */
// export const getMonthlyEvents = (year, month) =>
// request(`${API_EVENTS}calendar`, {
// method: 'GET',
// params: { yearMonth: `${year}-${month}` }
// }).then(response => response.events);

export const getMonthlyEvents = (fromDate, toDate) =>
  request(`${API_EVENTS}calendar`, {
    method: 'GET',
    params: {
      fromDate: convertDateToUTC(fromDate || new Date()),
      toDate: convertDateToUTC(toDate || new Date())
    }
  }).then(response => response.events);

export const getEvent = idEvent =>
  request(`${API_EVENTS}${idEvent}`, { method: 'GET' }).then(
    response => response
  );

export const getParticipateEvent = idEvent =>
  request(`${API_EVENTS_USER}${idEvent}`, { method: 'GET' }).then(
    response => response
  );

export const participateEvent = idEvent =>
  request(`${API_EVENTS_USER}${idEvent}/register`, { method: 'POST' });

export const noParticipateEvent = idEvent =>
  request(`${API_EVENTS_USER}${idEvent}/unregister`, { method: 'DELETE' });
